import { useTranslation } from 'react-i18next';
import Button from '../ui/Button';
import Card from '../ui/Card';

interface LockedFeatureBenefit {
  title: string;
  body: string;
}

interface LockedFeatureStateProps {
  tierLabel: string;
  title: string;
  description: string;
  benefits: LockedFeatureBenefit[];
  upgradeLabel: string;
  onUpgrade: () => void;
  onPricing: () => void;
  withCard?: boolean;
}

export default function LockedFeatureState({
  tierLabel,
  title,
  description,
  benefits,
  upgradeLabel,
  onUpgrade,
  onPricing,
  withCard = true,
}: LockedFeatureStateProps) {
  const { t } = useTranslation('dialogs');

  const content = (
    <>
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '6px 11px',
          borderRadius: 999,
          background: '#eef2ff',
          color: '#4f46e5',
          fontSize: 11,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          marginBottom: 18,
        }}
      >
        <span aria-hidden="true">🔒</span>
        {tierLabel}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 22 }}>
        <h2 style={{ margin: 0, fontSize: 24, fontWeight: 800, color: '#111827', letterSpacing: '-0.4px' }}>
          {title}
        </h2>
        <p style={{ margin: 0, color: '#6b7280', fontSize: 14, lineHeight: 1.7, maxWidth: 680 }}>
          {description}
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 12,
          marginBottom: 24,
        }}
      >
        {benefits.map((benefit) => (
          <div
            key={benefit.title}
            style={{
              border: '1px solid #e5e7eb',
              borderRadius: 12,
              background: '#fcfcfd',
              padding: '14px 16px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <span
                aria-hidden="true"
                style={{
                  width: 22,
                  height: 22,
                  borderRadius: 999,
                  background: '#eef2ff',
                  color: '#4f46e5',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 12,
                  fontWeight: 700,
                  flexShrink: 0,
                }}
              >
                +
              </span>
              <span style={{ fontSize: 13, fontWeight: 700, color: '#111827' }}>{benefit.title}</span>
            </div>
            <p style={{ margin: 0, color: '#6b7280', fontSize: 13, lineHeight: 1.6 }}>
              {benefit.body}
            </p>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <Button type="button" onClick={onUpgrade}>
          {upgradeLabel}
        </Button>
        <Button type="button" variant="secondary" onClick={onPricing}>
          {t('featureLock.viewFullPricing')}
        </Button>
      </div>
    </>
  );

  if (!withCard) {
    return content;
  }

  return (
    <Card style={{ padding: '28px 30px 30px' }}>
      {content}
    </Card>
  );
}
